import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    main: {
      marginBottom: '1rem'
    },
    box: {
      display: 'flex',
      justifyContent: 'center',
      padding: '1.5rem'
    },
    title: {
      height: '40px'
    }
  },
  subHeader: {
    main: {
      marginBottom: '1rem'
    },
    box: {
      display: 'flex',
      justifyContent: 'center',
      padding: '1.5rem'
    },
    title: {
      width: '500px',
      display: 'flex',
      justifyContent: 'space-between'
    },
    button: {
      width: '100%',
      height: '40px'
    },
    cardControl: {
      width: '100%',
      height: '100px'
    }
  },
  navigation: {
    main: {
      marginBottom: '1rem'
    },
    box: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0.5rem'
    },
    button: {
      width: '50px',
      height: '30px'
    }
  },
  content: {
    main: {
      marginBottom: '1rem'
    },
    box: {
      padding: '0.5rem'
    },
    text: {
      height: '280px'
    }
  },
  legend: {
    box: {
      height: '40px'
    },
    boxTwo: {
      height: '20px'
    }
  }
};

const SkeletonFareCalendarOIMobile = (props) => {
  const [className, style] = useStyles(props);
  const { header, subHeader, content, navigation, legend } = styles;
  return (
    <Box className={`${className} fr-skeleton`} style={style} dataTestId="skeletonLowFareCalendar">
      <Row gutters>
        <Col lg="4" style={header.main}>
          <Box className="fr-skeleton-element" style={header.title} />
        </Col>
      </Row>
      <Row gutters>
        <Col style={subHeader.main}>
          <Box className="fr-skeleton-element" style={subHeader.button} />
        </Col>
        <Col style={subHeader.main}>
          <Box className="fr-skeleton-element" style={subHeader.button} />
        </Col>
      </Row>
      <Row gutters>
        <Col style={subHeader.main}>
          <Box className="fr-skeleton-element" style={subHeader.cardControl} />
        </Col>
        <Col style={subHeader.main}>
          <Box className="fr-skeleton-element" style={subHeader.cardControl} />
        </Col>
      </Row>
      <Row gutters>
        <Col style={navigation.main}>
          <Box className="fr-skeleton-box" style={navigation.box}>
            <Box className="fr-skeleton-element" style={navigation.button} />
            <Box className="fr-skeleton-element" style={navigation.button} />
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col style={content.main}>
          <Box className="fr-skeleton-box" style={content.box}>
            <Box className="fr-skeleton-element" style={content.text} />
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col xs="5">
          <Box className="fr-skeleton-box" style={legend.boxTwo} />
        </Col>
      </Row>
    </Box>
  );
};

SkeletonFareCalendarOIMobile.componentName = 'SkeletonFareCalendarOIMobile';

export default SkeletonFareCalendarOIMobile;
